define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		postProcessSuccess: function() {
			// summary: refresh other rows referencing same color/material
			var	view = this.widget;
			var	urlMaster = this.getNode().Master;

			view.refreshDataRows(function(tr) {
				var rowNode = view.getRowNode(tr);
				return rowNode != null && urlMaster == rowNode.__Parent__;
			});
		}
	});
});
